export const config = {
  api_local: process.env.REACT_APP_API_URL, 
  BE_API_URL: process.env.REACT_APP_API_URL,
  site: process.env.REACT_APP_SITE,
  LIST_BANK_NAME: [
    'ABBANK',
    'ACB BANK',
    'AGRIBANK',
    'ANZBANK',
    'BAC A BANK',
    'BIDVBANK',
    'BVBANK',
    'CAKE',
    'CB BANK',
    'CIMB BANK',
    'CITI',
    'CO OPBANK',
    'DBS',
    'DONGA BANK',
    'EXIMBANK',
    'GB BANK',
    'HD BANK',
    'HNB',
    'HONGLEONG BANK',
    'HSBC',
    'IBK',
    'IndovinaBank',
    'KBANK',
    'KIENLONGBANK',
    'KOOKMI',
    'LIENVIET BANK',
    'LIOBANK',
    'MAFC',
    'MBBANK',
    'MBV BANK',
    'MOMO',
    'MODERN BANK OF VIETNAM',
    'MSB BANK',
    'NAMA BANK',
    'NCB',
    'NHB',
    'OCB BANK',
    'OCEANBANK',
    'PGBANK',
    'PVCOMBANK',
    'SACOMBANK',
    'SAIGONBANK',
    'SCB',
    'SCBVL',
    'SEABANK',
    'SHB BANK',
    'SHINHAN BANK VN',
    'TECHCOMBANK',
    'TIMO BANK',
    'TPBANK',
    'UBANK',
    'UOB',
    'VDB',
    'VIB BANK',
    'VIDPULICK BANK',
    'VIET CAPITAL BANK',
    'VIETA BANK',
    'VIETBANK',
    'VIETCOMBANK',
    'VIETINBANK',
    'VIETNAM BANK FOR SOCIAL POLICIES',
    'VPBANK',
    'VRB ( VIET NGA)',
    'WOORI BANK'
  ],
  LIST_REQUEST_BANK: [
    "Xóa số tài khoản",
    "Thêm số tài khoản",
    "Đổi số tài khoản",
  ],
};